<template>
  <div>
    <v-layout row class="ml-4 mt-4">
      <h2 :class="ui.textHeadline">
        {{this.companyTitle2}} sign out
      </h2>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card>
          <v-img
          class="white--text"
          :height="ui.sizeHeightDialogSmall"
          :src="require('@/app/assets/images/nature20.jpg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textTitle">
                   <a :class="ui.textColorWhite">
                     sign out
                   </a>
                 </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div :class="ui.textImage">
             nature photography
           </div>
         </v-layout>
         <v-layout row class="mt-3">
           <v-btn flat :color="ui.btnColor"
           :to="this.getPreviousPage">
             <v-icon left> exit_to_app </v-icon>
              back
           </v-btn>
           <v-spacer/>
           <div v-if="enableSpinner === false">
             <v-btn :color="ui.colorWarning" @click="signout" flat>
               <v-icon left> person_outline </v-icon>
               sign out
             </v-btn>
           </div>
           <div v-else>
             <BtnSpin :btnSpec="btnInfo1"/>
           </div>
         </v-layout>
         <v-layout row class="mt-4">
           <PublicFooterCard :data="{bkgd: 'white'}"/>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import signoutUser from "../mixins/signoutUser.js";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";

export default {
  components: {
    BtnSpin,
    PublicFooterCard
  },
  mixins: [currentPage, signoutUser, apptheme, publicGlobals],
  data: () => ({
    valid: true,
    currentPagePath: "/signout",
    enableSpinner: false,
    btnInfo1: {
      color: "keyboard_capslock",
      icon: "person",
      name: "sign out",
      size: "flat"
    }
  }),
  computed: {
    ...mapGetters(["getPreviousPage", "getCurrentPage"])
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
  }
};
</script>
